import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { getContext } from '@fiverr-private/fiverr_context';
import { selectRecipientInfo, selectSellerName, useStaticContext } from '../../../context/contexts/static';
import { getResponseTimeTextValue } from '../../../../utils/time';

const StayInTouchTitle = ({ showAppDownloadQr = false }) => {
    const { isMobile } = getContext();
    const context = useStaticContext();
    const { responseTimeInHrs } = selectRecipientInfo(context);
    const sellerName = selectSellerName(context);
    const responseTime = getResponseTimeTextValue(responseTimeInHrs);

    if (showAppDownloadQr) {
        return translate('send_message.sent_confirmation.encourage_app_download.message');
    } else if (responseTime) {
        const copiesSuffix = isMobile ? 'mobile_web' : 'web_new';

        const params = { sellerName, responseTime };

        return translate(`send_message.sent_confirmation.stay_in_touch.${copiesSuffix}`, { params });
    } else {
        return translate('send_message.sent_confirmation.stay_in_touch.web_no_response_time');
    }
};

export default StayInTouchTitle;
